import React from 'react';
import { withTranslation } from 'react-i18next';
import { OverlayTrigger } from 'react-bootstrap';
import { BsFilter } from "react-icons/bs";
import Utils from '../../core/utilities/Utils';
import './CustomTopicFilterStatus.scss';

const CustomTopicFilterStatus = ({ t, showOwnTopicsOnly, onFilterClick }) => {
    const getFilterTypeName = () => {
        return showOwnTopicsOnly ? t("CustomTopics.label") : t("AllTopics.label");
    };

    return (
        <div className="custom-topic-filter-status">
            {/* Filter Type Status */}
            {/* <span className="Filter_status">
                <h6>{t("TopicType.label")}: </h6>
                {getFilterTypeName()}
            </span> */}

            {/* Filter Icon */}
            <OverlayTrigger
                placement="top"
                overlay={Utils.renderTooltip(
                    t("Filter.label")
                )}>
                <button
                    className="btn btn-headbtn filter-icon"
                    onClick={onFilterClick}
                >
                    <BsFilter />
                </button>
            </OverlayTrigger>
        </div>
    );
};

export default withTranslation()(CustomTopicFilterStatus);
